import api from '@pray/shared/utils/api';

type RemoveBackgroundResponse = {
  url: string;
};

type RemoveBackgroundProps = {
  artistId: string;
  imageUrl: string;
};

export const removeBackground = async ({ artistId, imageUrl }: RemoveBackgroundProps) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!imageUrl) throw Error('Image URL is required');

  const url = `/web/studio/artists/${artistId}/images/remove-background`;
  const response = await api.executePostRequest<{ data: RemoveBackgroundResponse }>(url, { imageUrl });
  return response?.data?.data;
};
